import { useMemo } from 'react';
import { useOrgEvents } from 'hooks/orgEvents/orgEventHooks';
import { OrgEventListItem } from '../EventsTab/OrgEventListItem';
import { useSitStatAorScope } from './SitStatAorScopeContext';
import { scopeIncludesRegion } from './sitstat-aor-scope';

/**
 * SitStat Events widget — the same org-event cards the Events tab lists,
 * collapsed so a rail shows the roster of events rather than one expanded one.
 *
 * Archive and edit controls stay behind in the tab: they are chrome for
 * managing events, not for reading the situation.
 */
export function SitStatEventsWidget() {
  const { data: allEvents = [], isLoading } = useOrgEvents();
  const { scope } = useSitStatAorScope();
  const events = useMemo(
    () => allEvents.filter((event) => scopeIncludesRegion(scope, event.region)),
    [allEvents, scope]
  );

  if (isLoading) {
    return (
      <p className="tw:m-0 tw:text-xs tw:text-muted-foreground">
        Loading events…
      </p>
    );
  }

  if (events.length === 0) {
    return (
      <p className="tw:m-0 tw:text-xs tw:text-muted-foreground">
        {scope ? 'No active events in this AOR.' : 'No active events.'}
      </p>
    );
  }

  return (
    <div className="tw:max-h-80 tw:space-y-2 tw:overflow-y-auto tw:pr-0.5">
      {events.map((event) => (
        <OrgEventListItem key={event.id} event={event} defaultOpen={false} />
      ))}
    </div>
  );
}
